import { render, staticRenderFns } from "./Sponga.vue?vue&type=template&id=53a4bb04&"
import script from "./Sponga.vue?vue&type=script&lang=js&"
export * from "./Sponga.vue?vue&type=script&lang=js&"
import style0 from "./Sponga.vue?vue&type=style&index=0&id=53a4bb04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports